"use strict";

(function( $ ){
    const parseQueryAttributes = (query) => {
        const data = {};
        if(!query || query.length === 0) return data;
        let vars = query.split('&');
        for (let i = 0; i < vars.length; i++) {
            let pair = vars[i].split('=');
            data[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
        return data;
    }

    $(document).ready(function () {
        const locationAttrs = parseQueryAttributes(window.location.search.substring(1))
        $(document).find('.container-for-content a').each(function (){
            const href = $(this).attr('href').split('?');
            let linkAttrs = href[1].length > 0 ? parseQueryAttributes(href[1]) : {}
            for(let key in locationAttrs){
                linkAttrs[key] = locationAttrs[key];
            }
            linkAttrs = $.param(linkAttrs)
            $(this).attr('href', linkAttrs.length > 0 ? `${href[0]}?${linkAttrs}` : href[0]);
            $(this).click(function (){
                dataLayer.push({ event: 'advisor_click' });
            });
        });
    });

})( window.jQuery );


